<div class="mx-auto px-4">
  <div class="hidden md:block overflow-x-auto">
    <div class="mb-4">
      <p class="titre1 mt-4">
        {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.TITLE' | translate }}
        <mat-icon
        class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">settings</mat-icon>
      </p>
    </div>

    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex items-end justify-end mb-4 gap-3">
        <mat-select [(ngModel)]="filtreType" (selectionChange)="filtre()"
          placeholder="{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.ALL_TYPES' | translate }}"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="220">
          <mat-option value="">{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.ALL_TYPES' | translate }}</mat-option>
          <mat-option value="Groupe">{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.GROUPS' | translate }}</mat-option>
          <mat-option value="Entité seule">{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.SOLO_ENTITIES' | translate
          }}</mat-option>
        </mat-select>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="filtre()"
          placeholder="{{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="reinitialiserFiltre()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded"
            title="Réinitialiser">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortDataChange($event)"
          class="mat-table-novo">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.NAME' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
              {{ element.nom }}
            </td>
          </ng-container>
          <ng-container matColumnDef="aUtilisateursFictifs">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_UTILISATEURS_FICTIFS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.aUtilisateursFictifs ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="aAccesDiffusion">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_ACCES_DIFFUSION' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.aAccesDiffusion ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="aAccesIndex">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_ACCES_INDEX' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.aAccesIndex ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="aTenantSSO">
            <th mat-header-cell *matHeaderCellDef class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.A_TENANT_SSO' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.aTenantSSO ? 'Oui' : 'Non' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="neq">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.NEQ' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-2/10 px-4 py-2 border-b">
              {{ element.neq }}
            </td>
          </ng-container>
          <ng-container matColumnDef="idUnique">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-3/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.UNIQUE_ID' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-3/10 px-4 py-2 border-b">
              {{ element.idUnique }}
            </td>
          </ng-container>
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/10 px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.TYPE' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
              {{ element.type | translate }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="table-cell px-4 py-2">
              {{ 'PARAMETRES_ORGANISATIONS_MANAGEMENT.ACTIONS' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
              <button mat-icon-button (click)="editOrganisation(element.entiteId)">
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
        </table>
        @if (dataSource.filteredData.length === 0) {
          <div class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>
        }
        <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
          (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
        </mat-paginator>
      }
    </div>
  </div>